export const getPathForLangChange = (pathname: string, languageCode: string) => {
  if (pathname.startsWith('/en') || pathname.startsWith('/de')) {
    return pathname.replace(/^\/[a-z]{2}/, `/${languageCode}`);
  }

  return `/${languageCode}${pathname === '/' ? '' : pathname}`;
};
